import type { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class PartnerServiceWebservice {
  readonly #http = inject(HttpClient);

  lock = (serviceId: string): Observable<any> =>
    this.#http.patch<any>(`${environment.api.obendy}/v3/service/${serviceId}/lock`, null);

  unlock = (serviceId: string): Observable<any> =>
    this.#http.patch<any>(`${environment.api.obendy}/v3/service/${serviceId}/unlock`, null);

  readonly beaconUnlock = (serviceId: string, userId: string): void => {
    void fetch(`${environment.api.obendy}/v3/service/${serviceId}/unlock`, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      keepalive: true,
      body: JSON.stringify({ userId: userId }),
    });
  };
}
